<h2 mat-dialog-title>File Not Uploaded</h2>

<mat-dialog-content class="dialog-content">
  <div class="info-section">
    <div class="info-text center">
      Your file hasn't been uploaded yet. Leaving this screen will discard it.
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-raised-button [mat-dialog-close]="false" color="primary">
    Stay
  </button>
  <button mat-stroked-button [mat-dialog-close]="true">Leave Anyway</button>
</mat-dialog-actions>
